import { render, staticRenderFns } from "./RiskSparkline.vue?vue&type=template&id=7f9b33c2&"
import script from "./RiskSparkline.vue?vue&type=script&lang=js&"
export * from "./RiskSparkline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports